<template>
  <div>
    <h1>لیست فیدرها</h1>
    <div class="form-group">
      <input
        class="form-control mt-2 mb-2"
        placeholder="جستجو"
        type="text"
        dir="rtl"
        v-model="inpSearch"
        
        @keyup.enter="doSearch"
      />
      <!-- @keyup="doSearchDelayed" -->
    </div>

    <div class="row">
      <div class="col-12">
        <div class="list-group">
          <div
            v-bind:key="feeder.feeder_id"
            v-for="feeder in feederArrFiltered"
            class="list-group-item list-group-item-action"
            :class="{ 'list-group-item-warning': feeder.is_use > 0 }"
          >
            {{ feeder.feeder_name }}

            <router-link :to="'/feeder-c/' + feeder.feeder_id" class="btn btn-sm btn-outline-info">
              map
            </router-link>-
            
            <router-link
              target="_blank"
              :to="'/feeder-pre-cu-cal/' + feeder.feeder_id"
              class="btn btn-sm btn-outline-info"
            >
              محاسبه
            </router-link>-
            <router-link
              target="_blank"
              :to="'/feeder-print/' + feeder.feeder_id"
              class="btn btn-sm btn-outline-info"
            >
              print
            </router-link>-
            <router-link
              target="_blank"
              :to="'/feeder-print-ba3/' + feeder.feeder_id"
              class="btn btn-sm btn-outline-info"
            >
              screenshot
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
// import {ApiTls} from '../../src/app/tools/ApiTls';
import axios from "axios";
import { UrlTls } from '../app/tools/UrlTls';

export default {
  name: "FeederList",
  data() {
    return {
      feederArr: [],
      inpSearch: "",
      delayTimer: null,
      feederArrFiltered: [],
    };
  },
  created() {
      var Lockr = require("lockr");
      var f = Lockr.get('all_feeder_list_v1',[]);
    if(f.length >0){
this.feederArr = f;
this.feederArrFiltered = f.slice(0,5);
    }else{
  axios
      .get(UrlTls.getBaseUrl()+"/feeder")
      .then((res) => {
        console.log(res.data);
        this.feederArr = res.data;
        this.feederArrFiltered = res.data.slice(0,5);
        var Lockr = require("lockr");
      Lockr.set('all_feeder_list_v1',res.data);
      })
      .catch((e) => {
        console.log(e);
      });
    }
  

    // axios.get(UrlTls.getBaseUrl()+'/feeder/', function(res){
    //     console.log(res);
    //     // this.feederArr = res;
    // })
  },
  methods: {
    doSearchDelayed() {
      // clearTimeout(this.delayTimer);
      // this.delayTimer = setTimeout(this.doSearch, 1000);
      // this.doSearch();
    },
    doSearch() {
      if (this.inpSearch.length > 2) {
        this.feederArrFiltered = this.feederArr.filter(
          (row) => row.feeder_name.search(this.inpSearch) > -1
        );
      } else {
        this.feederArrFiltered = this.feederArr;
      }
    },
  },
  computed: {
    feederArrFiltered11() {
      if (this.inpSearch.length > 2) {
        return this.feederArr.filter(
          (row) => row.feeder_name.search(this.inpSearch) > -1
        );
      } else {
        return this.feederArr;
      }
    },
  },
};
</script>


<style  scoped>

</style>